import React from "react";
import { ArrowBack, ArrowForward, ContentPasteGo, SaveAlt } from "@mui/icons-material";
import { Box } from "@mui/material";
import Button from "@components/Button/Button.tsx";
import type { StepperControlsProps } from "@components/StepperControls/StepperControls.types.ts";
import { t } from "i18next";

const StepperControls: React.FC<StepperControlsProps> = ({
  prev,
  next,
  complete,
  cancel,
  save,
  completePending,
  savePending,
  nextLabelTranslationKey,
  backLabelTranslationKey,
  completeLabelTranslationKey = "stepper-controls.complete",
}) => {
  return (
    <Box data-testid="stepper-controls" className="flex justify-between">
      {cancel && (
        <Button
          variant="text"
          onClick={cancel}
          testId="stepper-cancel"
          type="button"
          label={<span className="normal-case font-medium">{t("stepper-controls.cancel")}</span>}
        />
      )}
      <Box className="flex gap-4 ml-auto">
        {save && (
          <Button
            variant="text"
            onClick={save}
            startIcon={<SaveAlt />}
            testId="stepper-save"
            type="button"
            loading={savePending}
            label={
              <span className="normal-case font-medium">{t("stepper-controls.save-as-draft")}</span>
            }
          />
        )}
        {prev && (
          <Button
            variant={backLabelTranslationKey ? "outlined" : "text"}
            onClick={prev}
            startIcon={<ArrowBack />}
            testId="stepper-back"
            type="button"
            label={
              <span className="normal-case font-medium">
                {backLabelTranslationKey ? t(backLabelTranslationKey) : t("stepper-controls.prev")}
              </span>
            }
          />
        )}
        {next && (
          <Button
            variant={nextLabelTranslationKey ? "outlined" : "contained"}
            onClick={next}
            endIcon={nextLabelTranslationKey === "submit" ? undefined : <ArrowForward />}
            testId={nextLabelTranslationKey === "submit" ? "stepper-submit" : "stepper-continue"}
            type="button"
            label={
              <span className="normal-case font-medium">
                {nextLabelTranslationKey ? t(nextLabelTranslationKey) : t("stepper-controls.next")}
              </span>
            }
          />
        )}
        {complete && (
          <Button
            variant="contained"
            onClick={complete}
            startIcon={<ContentPasteGo />}
            testId="stepper-complete"
            label={
              <span className="normal-case font-medium">{t(completeLabelTranslationKey)}</span>
            }
            loading={completePending}
          />
        )}
      </Box>
    </Box>
  );
};

export default StepperControls;
